import React from "react";
import { Redirect } from "react-router-dom";

export default function MatchScoreboardRedirect(props) {
  const matchId = props?.match?.params?.id;
  return <Redirect to={`/match/${matchId}#scoreboard`} />;
}
